import { Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CreateProfileLayout from "../../../Pages/layout";
import { routePaths } from "../../../routing/routePaths";
import CreateProfileCardWrapper from "../CreateProfileCardWrapper";
import CreateProfileCenterWrapper from "../CreateProfileCenterWrapper";
import CreateProfileHeader from "../CreateProfileHeader";

const GetStarted = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <CreateProfileLayout>
      <div className="income-details-right previous-hidden">
        <CreateProfileHeader IS_FINAL={true} />
        <CreateProfileCenterWrapper className="is-final mobile-responsive">
          <div className="row mx-0">
            <div className="col-12">
              <CreateProfileCardWrapper>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto">
                    <h2 className="text-center get-started-heading">
                      {t("gettingStart.title")}{" "}
                    </h2>
                    <h4 className="text-left">{t("gettingStart.line1")}</h4>
                    <br />
                    <h4 className="text-left">{t("gettingStart.line2")}</h4>
                    <br />
                    <h3 className="text-left">{t("gettingStart.subTitle")}</h3>
                    <h4 className="text-left">
                      {t("gettingStart.line3")}
                      <br />
                      <br />
                      {t("gettingStart.line4")}
                      <br />
                      <br />
                      {t("gettingStart.line5")}
                    </h4>
                    <Button
                      className="auth-theme-btn process-with-phase-btn get-started-btn"
                      onClick={() => {
                        navigate(routePaths.onboarding);
                      }}
                    >
                      {t("gettingStart.proceedBtn")}
                    </Button>
                  </div>
                </div>
              </CreateProfileCardWrapper>
            </div>
          </div>
        </CreateProfileCenterWrapper>
      </div>
    </CreateProfileLayout>
  );
};

export default GetStarted;
